import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { store } from './store';
import { ReporteInscripcion, ReportDTO } from '../models/ReporteInscritos';
import { UserList, UserListBusqueda, UserListFormValues, cuentasCursosList } from '../models/UsersList';
import { CambiarCorreoyContraseñaFormValues } from '../models/RecuperarUsuario';

export default class UsersListStore {

    BusquedaRegistry = new Map<any, any>();
    CuentasXcurso = new Map<any, cuentasCursosList>();
    
    selectedReporteInscritos: UserList | undefined = undefined;

    editMode = false;
    loading: boolean = false;
    loadingInitial = false;
    paginadorTotal = 0;
    PaginaInicial = true;
    U = []

    constructor() {
        makeAutoObservable(this)
    }

    get ReporteInscritosByCodigo() {
        return Array.from(this.BusquedaRegistry.values());
    }

    get CursosUsuarioByCodigo() {
        return Array.from(this.CuentasXcurso.values());
    }

    get groupedCCTiposDeCuentas() {
        return this.BusquedaRegistry
    }
    
    ListaCompletaUsuarios = async (pagina: any, delegacion: any): Promise<any[]> => {
        this.loadingInitial = true;
        this.BusquedaRegistry.clear()
        let usersForThisPage: any[] = [];
        try {
            const asignar: UserList = await agent.Account.listaUsuarios(pagina, delegacion)
            runInAction(() => {
                this.paginacionUsuarios(asignar.total)
                asignar.records.forEach((element) => {
                    this.setReporteInscritos(element)
                    usersForThisPage.push(element);
                })
            })
            this.setLoadingInitial(false)
        } catch (error) {
            console.error("Error cargando usuarios: ", error);
            this.setLoadingInitial(false);
        }
        return usersForThisPage;
    }
    

    CambiarContraseñaCorreo = async (credenciales: CambiarCorreoyContraseñaFormValues) => {
        this.loading = true;
        try{
            const cambiar = await agent.Account.cambiarCorreoyContraseña(credenciales)
            runInAction(() => {
                this.loading = false;
            })
        } catch(error){
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    BuscarUsuario = async (criterio: UserListBusqueda) => {
        this.loadingInitial = true;
        this.BusquedaRegistry.clear();
        this.setReporteInscritos([]); // Limpia la lista antes de agregar nuevos datos
        try {
            const buscar: any = await agent.Account.busquedaUsuario(criterio);
            if (Array.isArray(buscar.records)) {
                buscar.records.forEach((item: any) => {
                    this.setReporteInscritos(item);
                });
            } else {
                console.log("No se encontraron registros válidos:", buscar);
            }
            this.paginadorTotal = Math.ceil(buscar.total / 12);
            this.setLoadingInitial(false);
        } catch (error) {
            console.log("Error al buscar usuarios: ", error);
            this.setLoadingInitial(false);
        }
    }
    

    
    EliminarUsuario =async (usuario:string) => {
        this.loading = true
        try{
            await agent.Account.deleteUser(usuario)
            runInAction(() => this.loading = false)
        }catch(error){
            runInAction(() => this.loading = false)
        }
    }

    ListaCursosUsuario =async (usuario:string) => {
        this.loading = true
        this.CuentasXcurso.clear()
        try{
            const cuentas: cuentasCursosList[] = await agent.Account.cuentaXcurso(usuario)
            runInAction(() => {
                this.loading = false
                cuentas.forEach(item => {
                    this.setCuentasXcurso(item);
                })
            })
        }catch(error){
            runInAction(() => this.loading = false)
        }
    }

    private paginacionUsuarios = (total: any) => {
        let paginas = Math.ceil(total / 150) 
        this.paginadorTotal = paginas
    }

    private setReporteInscritos = (data: any) => {
        this.BusquedaRegistry.set(data.id, data);
    }

    private setCuentasXcurso = (data: cuentasCursosList) => {
        this.CuentasXcurso.set(data.courseName ,data);
    }

    setPaginaInicial = (state:boolean) =>{
        this.PaginaInicial = state
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }
}